import { render, staticRenderFns } from "./TabPartnerBenefits.vue?vue&type=template&id=19810509&"
import script from "./TabPartnerBenefits.vue?vue&type=script&lang=js&"
export * from "./TabPartnerBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports